export default __webpack_public_path__ + "static/media/Frame4.d42c1e05.png";